import { serverUrl } from './const'
// import { Message, Loading } from 'element-ui'
import { Message } from 'element-ui'
import webStorage from 'webStorage'
import $router from '../router'

$axios.defaults.baseURL = serverUrl
$axios.defaults.timeout = 100000
// $axios.defaults.headers['Content-Type'] = 'application/json; charset=UTF-8'
// $axios.defaults.headers.common['authKey'] = webStorage.getItem('userInfo_sn').authKey // 刷新时默认获取一次，统一设置auth移驾至登录接口
if (webStorage.getItem('userInfo_sn')) { // 处理刷新时authKey丢失
  $axios.defaults.headers.common['authKey'] = webStorage.getItem(
    'userInfo_sn').authKey
}
$axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'

// 添加一个请求拦截器
// let loadinginstace
$axios.interceptors.request.use((config) => {
  // TODO 考虑做全局loading效果，（注意html,body高度设为100%）
  // loadinginstace = Loading.service({
  //   fullscreen: true,
  //   background: 'rgba(0, 0, 0, 0.4)'
  // })
  return config
}, (error) => {
  // 当出现请求错误是做一些事
  // loadinginstace.close()
  Message.error({
    message: '加载超时',
  })
  return Promise.reject(error)
})

// 添加一个返回拦截器
$axios.interceptors.response.use((response) => {
  // 对返回的数据进行一些处理
  if (response.data.status === false) { // 后台返回错误
    if (response.data.errorCode) {
      setTimeout(() => {
        Message.error({message: response.data.errorCode.errorMsg})
      }, 0)
      setTimeout(() => {
        if (response.data.errorCode.code === '50005' ||
          response.data.errorCode.code === '50006') { // 50005未登录，50006登录过期
          // 后台返回得登录过期，重置登录状态
          //  $router.push({name: 'index'})
          let Arr = location.href.split('#') // 这里处理比较特殊
          $router.push({name: 'signin', query: {backUrl: Arr[1]}})
        }
      }, 1000)
    }
  }
  return Promise.resolve(response)
}, (error) => {
  // 对返回的错误进行一些处理
  // loadinginstace.close()
  Message.error({
    message: '好像发生了一点错误,需要检查！定位->' + error,
  })
  return Promise.reject(error)
})



// WEBPACK FOOTER //
// ./src/utils/axiosConfig.js